<template>
  <a-card :bordered="false">
    <a-form
      layout="inline"
      @keyup.enter.native="searchQuery"
      style="margin-bottom:8px"
    >
      <a-row :gutter="24">
        <a-col :md="6" :sm="8" :lg="6">
          <a-form-item
            label="消息类型"
            :wrapperCol="{ span: 18 }"
            :labelCol="{ span: 6 }"
          >
            <a-select
              v-model="screen.msgType"
              :defaultValue="''"
              :placeholder="'请选择'"
            >
              <a-select-option
                v-for="(item, index) in typeList"
                :key="index"
                :value="item.value"
              >
                {{ item.labal }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8" :lg="6">
          <a-form-item
            label="发送人"
            :wrapperCol="{ span: 18 }"
            :labelCol="{ span: 6 }"
          >
            <a-input v-model="screen.sendName" placeholder="请输入发送人昵称" />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="8" :lg="6">
          <a-form-item
            label="来源"
            :wrapperCol="{ span: 18 }"
            :labelCol="{ span: 6 }"
          >
            <a-select
              v-model="screen.source"
              :defaultValue="''"
              :placeholder="'请选择'"
            >
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="'1'">客户</a-select-option>
              <a-select-option :value="'2'">员工</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :lg="6" :md="6" :sm="8">
          <span
            style="float: left;overflow: hidden;"
            class="table-page-search-submitButtons"
          >
            <a-button type="primary" @click="goSearch" icon="search"
              >查询</a-button
            >
            <a-button
              type="primary"
              @click="searchReset"
              icon="reload"
              style="margin-left: 8px"
              >重置</a-button
            >
          </span>
        </a-col>
      </a-row>
    </a-form>
    <!-- <a-empty v-if="tableList.length==0" /> -->
    <div v-if="loading" class="nullchat">
      <!-- 暂无聊天! -->
      <a-spin />
    </div>
    <div v-else-if="tableList != undefined && tableList.length === 0">
      <a-empty />
    </div>
    <a-row v-else :gutter="24">
      <a-col :md="6" :sm="6" v-for="item in tableList" :key="item.msgid">
        <a-card :bordered="false">
          <template slot="cover">
            <div style="height:200px;overflow: hidden;">
              <img
                v-if="item.msgType == 'image'"
                :src="
                  imgUrl +
                    '/conversation/downloadChatData?sdkfileid=' +
                    item.sdkfileid
                "
                alt=""
                style="width: 100%;"
              />
              <audio
                v-if="item.msgType == 'voice'"
                controls
                style="width: 100%;line-height:200px;margin-top: 80px;"
              >
                <source
                  :src="
                    imgUrl +
                      '/conversation/downloadChatData?sdkfileid=' +
                      item.sdkfileid
                  "
                  type="audio/mpeg"
                />
                您的浏览器不支持音频播放。
              </audio>
              <video
                controls="controls"
                v-if="item.msgType == 'video'"
                width="100%"
              >
                <source
                  :src="
                    imgUrl +
                      '/conversation/downloadChatData?sdkfileid=' +
                      item.sdkfileid
                  "
                  type="video/mp4"
                />
                您的浏览器不支持 video 标签。
              </video>
              <a-icon
                v-else-if="item.msgType == 'file'"
                type="file-text"
                theme="twoTone"
                :style="{
                  fontSize: '80px',
                  height: '200px',
                  lineHeight: '200px',
                  width: '100%'
                }"
              />
            </div>
          </template>
          <a-card-meta
            :title="
              item.msgType == 'file' ? item.parsedMsgContent : item.msgTypeLabal
            "
          >
            <template slot="description">
              <a-icon type="file-text" />
              <!-- 发送人：{{item.sendName.substr(0,10)}}<br/>
              发送时间：{{item.msgtime}}<br/> -->
              <!-- 发送人：{{nameDemoList[(query.pageNo*rowIndex*4+colIndex)%nameDemoList.length]}}<br/> -->
              发送时间：{{ item.sendTime }}<br />
              <a
                :href="
                  imgUrl +
                    '/conversation/downloadChatData?sdkfileid=' +
                    item.sdkfileid
                "
                >下载</a
              >
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>
    <!-- 表格
    <a-table :columns="columns" :data-source="tableList" rowKey="msgid" :loading="loading" bordered :pagination="false">
      <template slot="parsedMsgContent" slot-scope="text,record">
        <div>
          <span v-if="record.msgtype=='file'">{{text}}</span>
          <img v-if="record.msgtype=='image'" src="https://www.w3school.com.cn/ui2017/compatible_chrome.png" alt="" style="width:80px;" />
          <audio v-if="record.msgtype=='voice'" controls>
            <source src="http://sc1.111ttt.cn/2017/1/05/09/298092035545.mp3" type="audio/mpeg" />
            您的浏览器不支持音频播放。
          </audio>
          <video width="430" height="270" controls autobuffer v-if="record.msgtype=='video'">
            <source src="http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" type="video/mp4">
            您的浏览器不支持 video 标签。
        </video>
        </div>
      </template>

      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="download(record.id)">下载</a>
      </template>
    </a-table>
    -->
    <!-- 分页 -->
    <a-pagination
      v-model="query.pageNo"
      :page-size-options="pageSizeOptions"
      :total="query.total"
      show-size-changer
      :page-size="query.pageSize"
      @showSizeChange="onShowSizeChange"
      @change="onChangeCurrent"
    >
    </a-pagination>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import { axios } from '@/utils/request';
const columns = [
  {
    title: '聊天内容',
    dataIndex: 'parsedMsgContent',
    key: 'parsedMsgContent',
    scopedSlots: {
      customRender: 'parsedMsgContent'
    }
  },
  {
    title: '发送人',
    dataIndex: 'sendName',
    key: 'sendName'
  },
  {
    title: '发送时间',
    dataIndex: 'msgtime',
    key: 'msgtime'
  },
  {
    title: '消息类型',
    dataIndex: 'msgTypeLabal'
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: {
      customRender: 'operation'
    }
  }
];
const typeList = [
  {
    labal: '全部',
    value: ''
  },
  {
    labal: '文件',
    value: 'file'
  },
  {
    labal: '图片',
    value: 'image'
  },
  {
    labal: '视频',
    value: 'video'
  },
  {
    labal: '音频',
    value: 'voice'
  }
];
const pageSizeOptions = ['30', '40', '50'];
export default {
  name: 'ChatDataListAll',
  created() {
    this.getList();
  },
  data() {
    return {
      columns,
      typeList,
      pageSizeOptions,
      query: {
        pageNo: 1,
        pageSize: 50,
        total: 0
      },
      tableList: [],
      loading: false,
      screen: {
        msgType: '',
        sendName: '',
        source: ''
      },
      url: {
        list: process.env.VUE_APP_CMS_CHATDATA + '/conversation/mediaList'
      },
      imgUrl: process.env.VUE_APP_GATEWAY_URL + process.env.VUE_APP_CMS_CHATDATA
    };
  },
  methods: {
    download(item) {
      axios({
        url:
          this.imgUrl +
          '/conversation/downloadChatData?sdkfileid=' +
          item.sdkfileid,
        method: 'get',
        responseType: 'blob'
      }).then(res => {
        console.log(res, item);
        // let params = xxx
        // const res = await this.$api.export(params);
        const blob = new Blob([res]); // 把得到的结果用流对象转一下
        let a = document.createElement('a'); //创建一个<a></a>标签
        a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
        a.download = '明细消息数据.xlsx'; //设置文件名
        a.style.display = 'none'; // 障眼法藏起来a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
      });
    },
    searchReset() {
      this.screen.msgType = '';
      this.screen.sendName = '';
      this.screen.source = '';
      this.getList();
    },
    onShowSizeChange(current, pageSize) {
      this.query.pageNo = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    onChangeCurrent(current) {
      this.query.pageNo = current;
      this.getList();
    },
    // 获取表格数据
    getList() {
      this.loading = true;
      getAction(this.url.list, {
        sendName: this.screen.sendName,
        msgType: this.screen.msgType,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        msgFrom: this.screen.source
      }).then(res => {
        this.loading = false;
        if (res.success) {
          this.tableList = res.result.list;
          console.log(this.tableList);
          // this.tableList.forEach((item, index) => {
          //   item.msgTypeLabal =  typeList.find(e=>e.value==item.msgtype).labal
          //   if(item.msgtype=='file'){
          //     const name = item.parsedMsgContent
          //     let index = name.lastIndexOf('.')
          //     let suffix = '';
          //     if (index != -1) {
          //       suffix = name.substring(index + 1, name.length)
          //     }
          //     suffix.toLowerCase();
          //     switch(suffix){
          //       case 'pdf':
          //         item.fileIcon = 'file-pdf'
          //         break
          //       case 'doc':
          //       case 'docx':
          //         item.fileIcon = 'file-word'
          //         break
          //       case 'xls':
          //       case 'xlsx':
          //         item.fileIcon = 'file-excel'
          //         break
          //       case 'ppt':
          //       case 'pptx':
          //         item.fileIcon = 'file-ppt'
          //         break
          //       case 'txt':
          //         item.fileIcon = 'file-text'
          //         break
          //       case 'zip':
          //       case 'rar':
          //       case '7z':
          //         item.fileIcon = 'file-zip'
          //         break
          //       default:
          //         item.fileIcon = 'file'
          //     }
          //   }
          //   const msgtime = new Date(item.msgtime);
          //   item.msgtime = msgtime.getFullYear()+"-"
          //     +this.fillZero(msgtime.getMonth()+1)+"-"
          //     +this.fillZero(msgtime.getDate())+" "
          //     +this.fillZero(msgtime.getHours())+":"
          //     +this.fillZero(msgtime.getMinutes())+":"
          //     +this.fillZero(msgtime.getSeconds());
          // })
          this.query.total = res.result.total;
        }
      });
    },
    fillZero(number) {
      return number < 10 ? '0' + number : '' + number;
    },
    goSearch() {
      this.query.pageNo = 1;
      this.getList();
    }
  }
};
</script>
<style scoped>
.ant-form-item {
  width: 100%;
}
.ant-row {
  margin-bottom: 8px;
}
.nullchat {
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
  font-size: 14px;
  font-weight: 400;
}
</style>
